export default {
  "content": "<rect width=\"48\" height=\"48\" rx=\"24\" fill=\"#4141A2\"/><g clip-path=\"url(#a)\" fill=\"#fff\"><path d=\"M19 24.001a2 2 0 100-4 2 2 0 000 4zM26 24a4 4 0 100-8 4 4 0 000 8zm3 2h-6a3 3 0 00-3 3v2.775a.225.225 0 00.225.225h11.55a.225.225 0 00.225-.225V29a3 3 0 00-3-3z\"/><path d=\"M21.535 25.287a1.2 1.2 0 00-.76-.287h-3.55A1.224 1.224 0 0016 26.225v3.591a.184.184 0 00.184.184H19v-1a4 4 0 012.535-3.713z\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" transform=\"translate(16 16)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "48",
    "height": "48",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};